import { assert, verify } from 'utils/assert';
import { assertInterface } from 'companion-app-components/utils/core';

assertInterface.assertInterfaceInit({ assert, verify });
